import React from 'react'
import { connect } from 'react-redux'
import { string, func, bool } from 'prop-types'
import FaStreetView from 'react-icons/lib/fa/street-view'
import { P, Option } from '../styles/option'
import { toggleStreetView } from '../../../../../store/Actions/UiActions'

const StreetviewButton = ({ address, toggleStreetView, online, theme }) => (
  <Option onClick={() => online && toggleStreetView(true)}>
    <FaStreetView color={theme} />
    <P theme={theme}>Streetview</P>
  </Option>
)

StreetviewButton.propTypes = {
  address: string.isRequired,
  toggleStreetView: func.isRequired,
  online: bool.isRequired,
  theme: string.isRequired,
}

const mapStateToProps = ({ signsState, spi }) => ({
  image: signsState.cache.streetViewImage,
  address: signsState.addressCache,
  online: spi.online,
  theme: spi.theme,
})

const mapDispatchToProps = dispatch => ({
  toggleStreetView: value => dispatch(toggleStreetView(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(StreetviewButton)



// WEBPACK FOOTER //
// ./src/components/Elements/SearchContent/OptionsButtons/StreetviewButton/index.jsx